<template>
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <br/><br/><br/><br/><br/><br/>
        <p class="page-title">Order Saved as Pending</p>
        <div class="g-my-20">
            <span class="order-confimation-description">
                Your order has been saved as a pending order. To continue to edit this order,
            </span>
            <br>
            <span class="order-confimation-description">go to the Track Order page.</span>
        </div>
      <br/><br/><br/>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                isPending:false
            }
        }
    }
</script>



// WEBPACK FOOTER //
// OrderPending.vue?5de07e93